import React from 'react';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import { Button } from '../../../../../components/ui/Button/Button';
import { FormSection, SectionTitle } from '../../styles/wizardStyles';
import { usePagamento } from '../../hooks/usePagamento';
import TaxCard from './TaxCard';
import PagamentoForm from './PagamentoForm';
import { ButtonGroup, InfoMessage } from './styles';

const PagamentoStep = ({ loading: externalLoading, onComplete, onBack, onGerarTitulo, paymentConfig, pedidoName = "Pedido", pagamentoInicial = null }) => {
  const {
    tipoPagamento,
    boletoGerado,
    tituloData,
    loading: internalLoading,
    error,
    valorTaxa,
    podeFinalizar,
    setTipoPagamento,
    handleGerarBoleto,
    handleFinalizar,
  } = usePagamento(paymentConfig, onComplete, onGerarTitulo, pagamentoInicial);

  const loading = externalLoading || internalLoading;

  if (!paymentConfig) {
    return (
      <FormSection>
        <SectionTitle>Erro de Configuração</SectionTitle>
        <InfoMessage style={{ background: '#fee2e2', color: '#dc2626' }}>
          ⚠️ Erro: Configuração de pagamento não encontrada.
        </InfoMessage>
        <ButtonGroup>
          <Button variant="secondary" onClick={onBack}>
            ← Voltar
          </Button>
        </ButtonGroup>
      </FormSection>
    );
  }

  return (
    <FormSection>
      <SectionTitle>
        Pagamento da Taxa de {pedidoName}
      </SectionTitle>

      <TaxCard valor={valorTaxa} pedidoName={pedidoName} />

      <PagamentoForm
        tipoPagamento={tipoPagamento}
        setTipoPagamento={setTipoPagamento}
        boletoGerado={boletoGerado}
        tituloData={tituloData}
        loading={loading}
        onGerarBoleto={handleGerarBoleto}
      />

      {error && (
        <InfoMessage style={{ background: '#fee2e2', color: '#dc2626' }}>
          ⚠️ {error}
        </InfoMessage>
      )}

      <ButtonGroup>
        {!boletoGerado && (
          <Button variant="secondary" onClick={onBack} disabled={loading} leftIcon={<FaArrowLeft />}>
            Voltar
          </Button>
        )}
        <Button
          variant="primary"
          onClick={handleFinalizar}
          disabled={loading || !podeFinalizar}
          leftIcon={<FaCheck />}
        >
          {loading ? 'Finalizando...' : 'Finalizar Requerimento'}
        </Button>
      </ButtonGroup>
    </FormSection>
  );
};

export default PagamentoStep;
